<header class="px-4 sm:px-6 py-4 flex items-center justify-between gap-4" role="banner">
  <!-- Greeting Section -->
  <div class="flex items-center justify-between gap-3 w-full">
    <div class="w-full">
      <h1 class="text-lg sm:text-xl font-bold text-(--color-text-main)">{{ getGreeting() }} {{ userName() }}</h1>
      <p class="text-sm text-text-muted hidden sm:block">Hope you have a good day</p>
    </div>

    <!-- Filters Section -->
    <div class="hidden lg:flex items-center gap-3" [class.w-full]="!isAdminRoleSelected()">
      <div class="lg:max-w-md" [class.w-full]="!isAdminRoleSelected()" [class.min-w-36]="isAdminRoleSelected()">
        <app-select size="sm" name="role" placeholder="Select role" [options]="roleOptions()" [searchable]="false"
          [ngModel]="selectedRole()" (ngModelChange)="selectedRole.set($event)" [required]="false" />
      </div>

      @if (!isAdminRoleSelected()) {
      <div class="w-full lg:max-w-md">
        <app-select size="sm" name="region" placeholder="Select Region" [options]="regionOptions()" [searchable]="false"
          [ngModel]="selectedRegion()" (ngModelChange)="onRegionChange($event)" [required]="false" />
      </div>

      @if (useFallbackCountryDropdown()) {
      <div class="w-full lg:max-w-md">
        <app-select [clearable]="true" size="sm" name="country-fallback" placeholder="Select Country"
          [options]="fallbackCountryOptions()" [ngModel]="selectedCountry()" (ngModelChange)="onCountryChange($event)"
          [required]="false" [searchable]="true" [onSearch]="onFallbackCountrySearch"
          [loading]="fallbackCountriesLoading()" (opened)="onFallbackCountryDropdownOpened()" />
      </div>
      } @else {
      <div class="w-full lg:max-w-md">
        <app-select [clearable]="true" size="sm" name="country" placeholder="Select Country" [options]="countryOptions()"
          [ngModel]="selectedCountry()" (ngModelChange)="onCountryChange($event)" [required]="false" />
      </div>
      }
      <div class="w-full lg:max-w-md">
        <app-select [clearable]="true" size="sm" name="dm-site" placeholder="Select DM Site"
          [options]="dmSiteOptions()" [ngModel]="selectedDmSite()" (ngModelChange)="onDmSiteChange($event)"
          [required]="false" [searchable]="true" [onSearch]="onDmSiteSearch" [loading]="dmSitesLoading()"
          [disabled]="selectedCountry() == null" (opened)="onDmSiteDropdownOpened()" />
      </div>
      }
    </div>
    <!-- Mobile Menu Toggle -->
    <button
      class="lg:hidden p-2  hover:bg-bg rounded-lg transition-colors focus:outline-none focus:ring focus:ring-border-subtle"
      aria-label="Toggle mobile menu" (click)="toggleMobileMenu()" [attr.aria-expanded]="showMobileMenu()">
      <svg class="w-6 h-6 text-text-strong" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
      </svg>
    </button>

    <!-- Actions Section -->
    <div class="flex items-center gap-2 sm:gap-3">
      <!-- Notifications -->
      <!-- <div class="relative notifications-container">
        <button (click)="toggleNotifications()"
          class="flex border border-border-subtle cursor-pointer p-1.5 bg-surface rounded-lg transition-colors focus:outline-none focus:ring focus:ring-border-subtle relative"
          aria-label="Notifications" size="sm" [attr.aria-expanded]="showNotifications()">

          <hugeicons-icon [icon]="Notification01Icon" [size]="18" color="currentColor"
            [strokeWidth]="1.5"></hugeicons-icon>
          <span class="absolute top-1 right-1 w-2 h-2 bg-error rounded-full"></span>
        </button>

        @if (showNotifications()) {
        <div
          class="absolute right-0 mt-2 w-80 bg-surface border border-border-subtle rounded-lg shadow-lg z-50 max-h-96 overflow-y-auto"
          role="menu" aria-label="Notifications menu">
          <div class="p-4 border-b border-border-subtle">
            <h3 class="font-semibold text-text-strong">Notifications</h3>
          </div>
          <div class="p-4 text-sm text-text-muted">No new notifications</div>
        </div>
        }
      </div> -->

      <!-- User Menu -->
      <div class="relative user-menu-container">
        <button (click)="toggleUserMenu()"
          class="flex shrink-0 border border-border-subtle cursor-pointer items-center gap-2 py-2 px-2 bg-surface rounded-lg transition-colors focus:outline-none focus:ring focus:ring-border-subtle"
          aria-label="User menu" size="sm" [attr.aria-expanded]="showUserMenu()">
          <div class="w-4 h-4 shrink-0 bg-primary rounded-full flex items-center justify-center">
            <span class="text-white text-xs font-semibold">{{ userName().charAt(0).toUpperCase() }}</span>
          </div>
          <span
            class="hidden text-xs sm:inline shrink-0 whitespace-nowrap truncate text-text-strong text-md font-medium">{{
            userName() }}</span>
          <hugeicons-icon [icon]="ArrowDownIcon" class="w-4 h-4" color="currentColor" [strokeWidth]="2"
            size="12"></hugeicons-icon>
        </button>

        @if (showUserMenu()) {
        <div class="absolute right-0 mt-2 w-48 bg-surface border border-border-subtle rounded-lg shadow-lg z-50"
          role="menu" aria-label="User menu">
          <div class="p-2">
            <a href="#"
              class="flex items-center gap-2 px-3 py-2 text-sm text-text-strong hover:bg-bg rounded-lg transition-colors"
              role="menuitem">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
              </svg>
              Profile
            </a>
            <a href="#"
              class="flex items-center gap-2 px-3 py-2 text-sm text-text-strong hover:bg-bg rounded-lg transition-colors"
              role="menuitem">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z">
                </path>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
              </svg>
              Settings
            </a>
            <div class="border-t border-border-subtle my-1"></div>
            <a (click)="logout()"
              class="flex items-center gap-2 px-3 py-2 text-sm text-error hover:bg-bg rounded-lg transition-colors"
              role="menuitem">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
              </svg>
              Logout
            </a>
          </div>
        </div>
        }
      </div>
    </div>
  </div>


</header>